export default __webpack_public_path__ + "img/pin_icons/exit_light_w.png";